const messages = {
  title: "Mantenimiento",
  description:
    'Actualmente se están realizando los trabajos de mantenimiento necesarios en los servidores.<br/><br/>Por lo tanto, actualmente no tiene acceso a <b>BRIDGESTONE <span class="text-danger">PLUS</span></b>.<br/><br/>Le pedimos paciencia y le agradecemos su comprensión.<br/><br/>Su equipo Bridgestone',
}
export default {
  messages
}
